import React from 'react';

import {
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { type Reading, label } from './liveModel';

type Props = {
  rows: Array<Reading>;
  dateKey: string;
  metrics: Array<string>;
  onInspect: (row: Reading) => void;
  metricLabel?: (key: string) => string;
};
export default function FinancialMatrix({ rows, dateKey, metrics, onInspect, metricLabel = label }: Props) {
  const regions = [...new Set(rows.map((row) => String(row.region ?? 'All markets')))];
  const text = (value: unknown) =>
    typeof value === 'number'
      ? value.toLocaleString('en-AU', { maximumFractionDigits: 2 })
      : String(value ?? 'Unknown');
  return (
    <Stack gap={3}>
      {regions.map((region) => {
        const scope = rows.filter((row) => String(row.region ?? 'All markets') === region);
        const dates = [...new Set(scope.map((row) => String(row[dateKey] ?? '')))].sort().reverse();
        return (
          <Stack key={region} gap={1}>
            <Typography variant="h6">{region}</Typography>
            <TableContainer component={Paper} variant="outlined" sx={{ maxWidth: '100%' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Measure · AUD or decimal ratio</TableCell>
                    {dates.map((date) => (
                      <TableCell key={date} align="right" sx={{ whiteSpace: 'nowrap' }}>
                        {date.slice(0, 10)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {metrics.map((metric) => (
                    <TableRow key={metric}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>{metricLabel(metric)}</TableCell>
                      {dates.map((date) => {
                        const row = scope.find((row) => String(row[dateKey] ?? '') === date);
                        return (
                          <TableCell key={date} align="right" sx={{ whiteSpace: 'nowrap' }}>
                            <Button size="small" onClick={() => row && onInspect(row)}>
                              {text(row?.[metric])}
                            </Button>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        );
      })}
    </Stack>
  );
}
